import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=f38f65d0&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailView.vue?vue&type=style&index=0&id=f38f65d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38f65d0",
  null
  
)

export default component.exports